export const ru = {
  app: {
    name: 'Маджонг',
    title: 'Маджонг',
  },
  seo: {
    title:
      'Маджонг на четверых — научиться играть онлайн с тренером | BN-games',
    description:
      'Научитесь играть в настоящий маджонг на четверых: уроки, тренер, который подсказывает сброс и объясняет почему, китайские классические правила и онлайн-столы, где пустые места занимают боты. Бесплатно.',
    social:
      'Научитесь играть в маджонг на четверых с уроками и тренером, а потом играйте онлайн с друзьями и ботами.',
    h1:
      'Маджонг онлайн: учиться и играть',
    intro:
      'Это маджонг как игра на четверых, а не пасьянс «Маджонг». Каждый игрок собирает из четырнадцати костей четыре комбинации и пару, набирая кости из стены и забирая сбросы соперников.\n\nBN-games учит игре шаг за шагом: тренажёр с шестью уроками, тренер, который подсказывает сброс и объясняет почему, и глоссарий костей, комбинаций и заявок. Когда будете готовы — играйте в китайский классический маджонг с конгами, традиционным подсчётом очков и матчами на Восток и Юг или откройте онлайн-стол для друзей: пустые места займут боты.',
    rulesTitle:
      'Правила маджонга для начинающих — кости, комбинации, заявки | BN-games',
    rulesDescription:
      'Правила маджонга для начинающих: масти и кости, четыре комбинации и пара, заявки панг, чи и конг, порядок хода.',
    rulesH1:
      'Правила маджонга для начинающих',
    playCta:
      'Начать учиться маджонгу',
  },
  common: {
    back: '← Назад',
  },
  auth: {
    signIn: 'Войти',
    signOut: 'Выйти',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Заполните профиль →',
    profile: 'Профиль',
    backToLanding: '← BN-games',
  },
  social: {
    close: 'Закрыть',
    invite: {
      message: '{{sender}} приглашает вас в {{game}}',
      moreCount_one: '+{{count}} ещё приглашение',
      moreCount_few: '+{{count}} ещё приглашения',
      moreCount_many: '+{{count}} ещё приглашений',
      moreCount_other: '+{{count}} ещё приглашений',
      accept: 'Принять',
      decline: 'Отклонить',
      acceptAria: 'Принять приглашение от {{sender}} в {{game}}',
      declineAria: 'Отклонить приглашение от {{sender}} в {{game}}',
    },
    dock: {
      pillLabel: 'От {{sender}}',
      pillAria: 'Приглашение от {{sender}} в {{game}} — показать',
      popoverLabel: 'Приглашение',
      close: 'Закрыть приглашение',
      leaveGameTitle: 'Покинуть игру?',
      leaveGameBody: 'Приглашение откроет {{game}}, а текущая партия будет прервана. В онлайн-игре ваше место какое-то время сохраняется — вы сможете вернуться.',
      leaveGameConfirm: 'Выйти и присоединиться',
      leaveGameCancel: 'Остаться',
    },
    friendPicker: {
      button: 'Пригласить друга',
      modalTitle: 'Пригласить друга',
      loading: 'Загрузка друзей…',
      signInPrompt: 'Войдите, чтобы пригласить друга.',
      empty: 'У вас пока нет друзей.',
      findFriends: 'Найти друзей',
      invite: 'Пригласить',
      inviteAria: 'Пригласить {{name}}',
      invited: 'Приглашён',
      invitedAria: '{{name}} приглашён',
      notAccepting: 'Этот игрок сейчас не принимает приглашения',
      retryIn: 'Повторите через {{seconds}} с',
    },
    addOpponent: {
      buttonMany: 'Добавить друзей…',
      modalTitle: 'Добавить друзей',
      add: 'Добавить {{name}} в друзья',
      added: 'Добавлен',
      addedAria: '{{name}} добавлен в друзья',
    },
  },
  menu: {
    play: 'Играть',
    freePlay: 'Свободная игра',
    lessons: 'Уроки',
    playOnline: 'Игра по сети',
    joinOnline: 'Присоединиться',
    comingSoon: 'Скоро',
    rules: 'Правила',
    settings: 'Настройки',
    about: 'Об игре',
    resume: 'Продолжить',
    resumeOnline: 'Продолжить онлайн ({{code}})',
  },
  pause: {
    title: 'Пауза',
    openTooltip: 'Меню паузы',
    resume: 'Продолжить',
    settings: 'Настройки',
    quit: 'Выйти в меню',
  },
  about: {
    title: 'Об игре',
    body: 'Тренажёр для изучения упрощённого маджонга — один живой игрок против трёх ботов. Прочитайте глоссарий, чтобы разобраться в плитках, наборах и объявлениях, а затем сыграйте полную раздачу.',
  },
  game: {
    yourTurn: 'Ваш ход',
    seatTurn: 'Ход игрока {{seat}}',
    seatEast: 'Восток',
    seatSouth: 'Юг',
    seatWest: 'Запад',
    seatNorth: 'Север',
    discard: 'Сброс',
    draw: 'Взять',
    wallCount: 'Осталось плиток: {{count}}',
    tsumo: 'Цумо',
    ron: 'Рон',
    exhausted: 'Ничья',
    winner: 'Победа: {{seat}}',
    nextHand: 'Следующая раздача',
  },
  claim: {
    pung: 'Пон',
    chi: 'Чи',
    ron: 'Рон',
    kong: 'Кан',
    tsumo: 'Цумо',
    skip: 'Пропустить',
  },
  tile: {
    suitMan: 'Символы',
    suitPin: 'Кружки',
    suitSou: 'Бамбук',
    windEast: 'Восточный ветер',
    windSouth: 'Южный ветер',
    windWest: 'Западный ветер',
    windNorth: 'Северный ветер',
    dragonRed: 'Красный дракон',
    dragonGreen: 'Зелёный дракон',
    dragonWhite: 'Белый дракон',
  },
  coach: {
    title: 'Тренер',
    hide: 'Скрыть тренера',
    setsCount: 'Готовых наборов: {{n}}',
    pairOne: '1 пара',
    pairNone: 'пары пока нет',
    floatersCount: 'Лишних плиток: {{n}}',
    hint: 'Подсказка',
    tileName: '{{suit}} {{rank}}',
    discardIntro: 'Стоит сбросить: {{tile}}',
    claimTitle: 'Можно объявить',
    reason: {
      loneHonor: 'Эта почётная плитка не образует последовательность — балласт.',
      terminal: 'Краевая плитка ({{tile}}) сочетается хуже, чем средние.',
      noConnection: 'У плитки {{tile}} нет соседей для набора или пары.',
      excessCopy: 'У вас уже есть три таких — лишняя {{tile}} не нужна.',
    },
    claim: {
      ron: 'Рон — этот сброс завершает вашу руку. Можно выиграть!',
      pung: 'Пон — так вы соберёте тройку.',
      chi: 'Чи — так вы соберёте последовательность.',
    },
  },
  lesson: {
    listTitle: 'Уроки',
    empty: 'Уроки скоро появятся.',
    progress: 'Шаг {{n}} из {{total}}',
    next: 'Далее',
    skip: 'Пропустить урок',
    exit: 'Выйти из урока',
    tryAgain: 'Ещё раз',
    complete: 'Урок пройден!',
    wrongTile: 'Не та плитка — следуйте подсветке и попробуйте снова.',
    wrongAction: 'Этот шаг учит другому действию. Попробуйте снова.',
    notYourTurn: 'Сейчас не ваш ход для этого действия.',
    illegalMove: 'Эту плитку сейчас нельзя сбросить.',
    cannotClaim: 'Здесь нельзя сделать такое объявление.',
    cannotTsumo: 'Ваша рука ещё не завершена.',
    shouldClaim: 'Этот сброс стоит забрать — действуйте.',
    script: {
      tiles: {
        title: 'Плитки и семейства',
        intro: 'Добро пожаловать! В маджонге 136 плиток. Прежде чем сделать ход, познакомимся с семействами в вашей руке.',
        suits: 'Три числовые масти идут от 1 до 9: Символы, Кружки и Бамбук. Подсвечены по одной плитке каждой масти.',
        winds: 'Четыре ветра — Восток, Юг, Запад, Север — почётные плитки без числа. Здесь подсвечены две из них.',
        dragons: 'Три дракона — Красный, Зелёный, Белый — это другие почётные плитки. Ваш Красный дракон подсвечен.',
        tryDiscard: 'Ход заканчивается сбросом одной плитки. Нажмите на подсвеченный 7-Бамбук, чтобы отправить его в сброс.',
        done: 'Вот и все семейства. Запомните: почётные плитки не образуют последовательностей — это пригодится при изучении наборов.',
      },
      firstRun: {
        title: 'Ваша первая последовательность',
        intro: 'Последовательность — три идущие подряд плитки одной масти. У вас есть 3 и 4 Символов — их завершит 2 или 5.',
        discard: 'Белый дракон стоит особняком и не войдёт в последовательность. Сбросьте его, чтобы сохранить набор.',
        done: 'Отлично. Держать связанные плитки и избавляться от одиночек — основа сбора руки.',
      },
      triplets: {
        title: 'Тройки и пара',
        intro: 'Две одинаковые плитки могут вырасти в тройку, а в каждой выигрышной руке нужна ровно одна пара. У вас две 5-Бамбука и две 3-Кружка.',
        discard: 'Одинокий Западный ветер ни с чем не сочетается. Сбросьте его и сохраните пары.',
        done: 'Одна пара станет вашей парой, другая может вырасти в тройку. Одинаковые плитки стоит держать.',
      },
      pung: {
        title: 'Объявление Пон',
        intro: 'У вас пара Красных драконов. Если любой игрок сбросит третьего, вы можете объявить Пон и собрать открытую тройку.',
        discard: 'Сначала сбросьте ненужную плитку — одинокого Белого дракона. Затем следите за другими игроками.',
        claim: 'Сброшен Красный дракон! Нажмите Пон, чтобы забрать его и завершить тройку.',
        done: 'Вы собрали открытый Пон. После любого объявления вы сбрасываете, не беря плитку, — теперь ваш ход.',
      },
      chi: {
        title: 'Объявление Чи',
        intro: 'Чи завершает последовательность, но только от игрока слева от вас. У вас 2 и 3 Бамбука, ждёте единицу.',
        discard: 'Сбросьте одинокого Белого дракона, пока ждёте нужную плитку.',
        reading: 'Следите за сбросами соперников — они намекают, что игроку не нужно. Игрок слева только что сбросил 1-Бамбук, завершающий вашу последовательность.',
        claim: 'Нажмите Чи, чтобы забрать 1-Бамбук и собрать последовательность Бамбука.',
        done: 'Это объявленная последовательность. Запомните: Пон — от любого, а Чи — только от игрока слева.',
      },
      winning: {
        title: 'Выигрыш — Цумо и Рон',
        intro: 'Вашей руке не хватает одной плитки: три последовательности, пара Красных драконов и 5-6 Бамбука в ожидании 4 или 7.',
        discard: 'Сбросьте одинокого Белого дракона — все остальные плитки уже работают.',
        ways: 'Выиграть можно двумя способами: взять нужную плитку самому (Цумо) или забрать её из сброса другого игрока (Рон).',
        tsumo: 'Вы взяли 7-Бамбук — рука завершена! Объявите Цумо, чтобы выиграть.',
        done: 'Вы выиграли через Цумо. Если бы 7-Бамбук сбросил соперник, вы объявили бы Рон. Поздравляем!',
      },
    },
  },
  match: {
    round: 'Круг: {{round}}',
    dealer: 'Раздающий: {{seat}}',
    you: 'Вы',
    score: '{{seat}}: {{points}}',
  },
  score: {
    points: 'Очки: {{n}}',
    patterns: {
      wonHand: 'Победа',
      selfDrawn: 'Бонус за цумо',
      meldPoints: 'Очки за наборы',
      pairBonus: 'Бонус за пару',
      sevenPairs: 'Семь пар',
      allTriplets: 'Все тройки',
      allSimples: 'Все простые',
      halfFlush: 'Смешанная одна масть',
      fullFlush: 'Чистая одна масть',
      allHonors: 'Все почётные',
      mixedTerminals: 'Смешанные крайние',
      pureTerminals: 'Чистые крайние',
      greatDragons: 'Большие драконы',
      greatWinds: 'Большие ветра',
      thirteenOrphans: 'Тринадцать сирот',
      heavenlyHand: 'Небесная рука',
      earthlyHand: 'Земная рука',
    },
  },
  online: {
    overlay: {
      playerDisconnected: 'Игрок отключился',
      waitingForReconnection: 'Стол на паузе — на переподключение осталось {{countdown}}.',
      reconnecting: 'Переподключение…',
      restoringGame: 'Восстанавливаем ваше место — осталось {{countdown}}.',
      connectionLost: 'Связь потеряна',
      gameEnded: 'Этот стол больше недоступен.',
      rematchOffered: 'Реванш предложен',
      waitingForOthers: 'Ждём остальных игроков…',
      rematchRequested: 'Игрок предлагает реванш',
      rematchPrompt: 'Реванш начинает совершенно новый матч.',
      rematchDeclined: 'Реванш отклонён',
      gameOverWin: 'Вы победили',
      gameOverLoss: 'Вы проиграли',
      gameOverDraw: 'Ничья',
      gameOverPrompt: 'Сыграем ещё?',
      buttons: {
        leave: 'Выйти',
        rematch: 'Реванш',
        returnToMenu: 'В меню',
        cancel: 'Отмена',
        accept: 'Принять',
        decline: 'Отклонить',
      },
    },
    rematchConfirm: {
      title: 'Начать новый матч?',
      message:
        'Матч ещё не закончен. Реванш раздаёт совершенно новый — текущие очки, круг и раздающий будут потеряны.',
      confirm: 'Новый матч',
      cancel: 'Продолжить',
    },
    create: {
      title: 'Создать стол',
      rulesetLabel: 'Правила',
      humansLabel: 'Игроки',
      botsHint: 'За каждое свободное место сядет бот.',
      verifiableLabel: 'Проверяемая раздача',
      verifiableHint: 'Стена тасуется из публичного источника случайности, поэтому любой может убедиться, что раздача честная.',
      on: 'Вкл',
      off: 'Выкл',
      submit: 'Создать стол',
      connecting: 'Подключение…',
      error: 'Не удалось связаться с сервером. Попробуйте ещё раз.',
    },
    join: {
      title: 'Присоединиться к столу',
      codeLabel: 'Код комнаты',
      codeHint: 'Четыре символа — от того, кто создал стол.',
      submit: 'Войти',
      connecting: 'Подключение…',
      error: 'Не удалось присоединиться к столу. Попробуйте ещё раз.',
      errorNotFound: 'Стола с таким кодом нет. Проверьте код и попробуйте снова.',
      errorFull: 'Этот стол уже заполнен.',
    },
    lobby: {
      title: 'Стол',
      codeLabel: 'Код комнаты',
      copyCode: 'Копировать',
      copied: 'Скопировано',
      share: 'Передайте этот код тем, кто к вам присоединится.',
      rulesetLabel: 'Правила: {{ruleset}}',
      verifiableOn: 'Проверяемая раздача включена.',
      seat: 'Место {{n}}',
      you: 'Вы',
      bot: 'Бот',
      open: 'Ожидание…',
      startNow: 'Начать сейчас',
      startNowHint: 'Начнёт немедленно — за каждое свободное место сядет бот.',
      leave: 'Покинуть стол',
      status: {
        connecting: 'Подключение…',
        waiting: 'Ожидание игроков…',
        ready: 'Все в сборе — начинаем.',
        error: 'Связь со столом потеряна.',
      },
    },
    resumeModal: {
      reconnectingTitle: 'Переподключение…',
      reconnectingBody: 'Переподключаемся к вашему столу…',
      seatTakenTitle: 'Место занято',
      seatTakenBody: 'Это место принадлежит другому аккаунту. Войдите под тем аккаунтом или начните новый стол.',
      roomGoneTitle: 'Стол закрыт',
      roomGoneBody: 'Этого стола больше нет — он закрылся или никогда не открывался здесь.',
      roomFullTitle: 'Стол заполнен',
      roomFullBody: 'Все места за этим столом заняты, и ни одно из них не ваше.',
      anonymousTitle: 'Не можем подтвердить, что это место ваше',
      anonymousBody: 'В этом браузере нет записи об этом столе. Войдите в аккаунт перед следующей онлайн-игрой, и ваше место будет доступно с любого устройства.',
      unreachableTitle: 'Не удалось связаться с сервером',
      unreachableBody: 'Сервер не отвечает. Проверьте соединение и попробуйте снова.',
      signIn: 'Войти',
      retry: 'Повторить',
    },
  },
  verify: {
    openButton: 'Проверить раздачу',
    title: 'Проверка раздачи',
    explainer:
      'Стена этой раздачи перемешана по публичному маяку случайности. Раздача закончилась, поэтому её зерно можно раскрыть: проверка заново выводит стену из раунда маяка и подтверждает, что её никто не выбирал.',
    source: 'Источник',
    chain: 'Цепочка',
    signedBy: 'Подпись',
    round: 'Раунд',
    randomness: 'Случайность',
    room: 'Код комнаты',
    seed: 'Зерно стены',
    derivedSeed: 'Выведенное зерно',
    statusPending: 'Проверяем…',
    statusVerified: 'Проверено — стена получена из маяка.',
    statusSeedMismatch: 'Стена не соответствует этому раунду маяка.',
    statusSigInvalid: 'Доказательство недействительно.',
    statusUnverified: 'Для этой раздачи нет доказательства.',
    close: 'Закрыть',
  },
  settings: {
    title: 'Настройки',
    language: 'Язык',
    theme: 'Тема',
    coach: 'Подсказки тренера',
    turnStartSound: 'Звук начала хода',
    variant: 'Правила',
    languages: {
      en: 'English',
      ru: 'Русский',
    },
    variants: {
      simplified: 'Упрощённые',
      classical: 'Классические',
    },
  },
  rules: {
    title: 'Правила и глоссарий',
    tileFamilies: 'Семейства плиток',
    tileFamiliesBody:
      'Плитки маджонга делятся на три числовые масти и две группы почётных плиток.\n\nСимволы (萬, «ман») — от 1 до 9. Кружки (筒, «пин») — от 1 до 9, изображаются кольцами из точек. Бамбук (索, «соу») — от 1 до 9, изображается зелёными палочками.\n\nПочётные плитки не имеют ранга. Четыре ветра — Восток, Юг, Запад и Север. Три дракона — Красный, Зелёный и Белый. Каждая из 34 различных плиток встречается по четыре раза, всего 136 плиток.',
    sets: 'Наборы',
    setsBody:
      'Выигрышная рука — это четырнадцать плиток, собранные в четыре набора и одну пару.\n\nПоследовательность — три идущие подряд плитки одной масти, например 3-4-5 кружков; почётные плитки последовательностей не образуют. Тройка — три одинаковые плитки, например три Восточных ветра. Пара — две одинаковые плитки, и в каждой выигрышной руке нужна ровно одна пара.',
    calls: 'Объявления',
    callsBody:
      'Когда другой игрок сбрасывает нужную вам плитку, вы можете забрать её вне очереди.\n\nПон — забрать сброс любого игрока, чтобы собрать тройку. Чи — забрать сброс, чтобы собрать последовательность, но только у игрока слева от вас (сидящего прямо перед вашим ходом). Рон — забрать сброс, завершающий всю вашу руку, и выиграть. Цумо — выигрыш на плитке, которую вы взяли сами. После Пона или Чи вы берёте плитку, открываете набор и сбрасываете, не беря новую.',
    turnFlow: 'Ход игры',
    turnFlowBody:
      'В свой ход вы берёте одну плитку из стены. Если она завершает руку, можно объявить Цумо и выиграть; иначе вы сбрасываете одну плитку лицом вверх.\n\nПосле сброса любой другой игрок может забрать эту плитку. Если её хотят несколько игроков, Рон важнее Пона, а Пон важнее Чи. Если никто не забирает, берёт следующий игрок. Если стена заканчивается раньше, чем кто-то выиграл, раздача завершается без победителя.',
  },
};
